// src/features/Management/page/Action

import DynamicTable from '@/common/components/DynamicTable/DynamicTable';
import type { ColumnsType } from 'antd/es/table';
import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import type { ActionType } from '../../types/managementTypes';



const ActionPage = () => {
  

    // Define columns for the Action table
    const actionColumns: ColumnsType<ActionType> = [
        { title: "Controller Name", dataIndex: "controllerName", key: "controllerName", sorter: true },
        { title: "Action Name", dataIndex: "actionName", key: "actionName" },
    ];

    return (
        <div>
            
            <DynamicTable<ActionType> // Ensure generic type matches the data
                dataApiUrl={API_ENDPOINTS.MANAGEMENT.GET_ACTIONS} // Your API endpoint for fetching menus
                baseQueryKey={QUERY_KEYS.MANAGEMENT.ACTIONS} // Unique query key for menus
                columns={actionColumns}
                showActions={false} // Set to true if you want Edit/Delete actions
                tableTitle={"Action Management"}
            />
        </div>
    );
};

export default ActionPage;